<template>
  <div v-if="show">
    <div class="menuFrame">
      <section id="login">
        <div class="container py-3">
          <div class="row flex-nowrap mx-2 pt-3 justify-content-between align-items-center">
            <a href="https://www.chanchao.com.tw/vn/">
              <div class="d-flex align-items-center">
                <img src="../../assets/images/ChanChaoLogo.png" class="navLogo mt-2" />
                <div class="mx-2 logoText text-dark font-weight-nomal">
                  <div>Hội viên Chan Chao</div>
                </div>
              </div>
            </a>
            <div class="d-flex mr-3">
              <a :href="`https://www.chanchao.com.tw/accounts/resetPw?e=${menberId}&c=${verifyCode}`">
                <img src="../../assets/images/langTW.svg" style="width: 17px; height: 17px" class="mb-1 mr-md-0 mr-2" />
                <span class="navEnText text-muted mr-3"> 中文版 </span>
              </a>

              <a :href="`https://www.chanchao.com.tw/accounts/en/resetPw?e=${menberId}&c=${verifyCode}`">
                <img src="../../assets/images/lang.svg" style="width: 17px; height: 17px" class="mb-1 mr-md-0 mr-2" />
                <span class="navEnText text-muted mr-3"> English </span>
              </a>

              <a :href="`https://www.chanchao.com.tw/accounts/th/resetPw?e=${menberId}&c=${verifyCode}`">
                <img src="../../assets/images/th.svg" style="width: 17px; height: 17px" class="mb-1" />
                <span class="navEnText text-muted ml-1"> ภาษาไทย </span>
              </a>
            </div>
          </div>
        </div>

        <div class="container">
          <div class="row formFrame m-1 py-2 mr-3 justify-content-center">
            <div class="col-md-6 my-4 px-4">
              <div class="d-flex align-items-center">
                <img src="../../assets/images/PwIcon.png" class="mr-2 mb-2" style="width: 40px; height: 40px" alt="" />
                <h4 class="title_family">Cài đặt lại mật khẩu</h4>
              </div>
              <p class="my-4">Xin hãy cài đặt lại mật khẩu mới của bạn</p>
              <form>
                <div class="form-group h6">
                  <label for="resetPassword1" class="title_family">Mật khẩu mới</label>
                  <div class="input-group mb-3">
                    <input
                      type="password"
                      :type="typePwd"
                      class="form-control"
                      id="resetPassword1"
                      autocomplete="off"
                      placeholder="Mật khẩu 8-20 ký tự"
                      maxlength="20"
                      aria-describedby="emailHelp"
                      v-model="password"
                      name="password"
                      :class="{ 'is-invalid': errors.first('password') }"
                      v-validate="'required'"
                      ref="password"
                      data-vv-as="password"
                    />
                    <div class="input-group-append">
                      <span class="input-group-text" id="basic-addon2" @click.prevent="showPw">
                        <i class="fas fa-eye" v-if="typePwd == 'password'"></i>
                        <i class="fas fa-eye-slash" v-else="typePwd == 'text'"></i>
                      </span>
                    </div>
                  </div>
                  <span class="text-danger title_family" style="font-size: 10px" v-if="errors.first('password')"
                    >{{ errors.first('password') }}
                  </span>
                </div>

                <div class="form-group h6">
                  <label for="resetPassword2" class="title_family">Xác nhận mật khẩu mới</label>
                  <div class="input-group mb-3">
                    <input
                      type="password"
                      :type="typePwd"
                      class="form-control"
                      id="resetPassword2"
                      autocomplete="off"
                      placeholder="Nhập lại mật khẩu mới"
                      maxlength="20"
                      aria-describedby="emailHelp"
                      v-model="confirmcode"
                      name="password_confirmation"
                      :class="{
                        'is-invalid': errors.first('password_confirmation'),
                      }"
                      v-validate="'required|confirmed:password'"
                      data-vv-as="password_confirmation"
                      ref="passwordconfirm"
                    />

                    <div class="input-group-append">
                      <span class="input-group-text" id="basic-addon2" @click.prevent="showPw">
                        <i class="fas fa-eye" v-if="typePwd == 'password'"></i>
                        <i class="fas fa-eye-slash" v-else="typePwd == 'text'"></i>
                      </span>
                    </div>
                  </div>
                  <span
                    class="text-danger title_family"
                    style="font-size: 10px"
                    v-if="errors.first('password_confirmation')"
                    >{{ errors.first('password_confirmation') }}
                  </span>
                </div>
                <button type="submit" class="btn btn-block btn-primary mt-4" @click.prevent="resetPw">
                  Thay đổi mật khẩu
                </button>
              </form>

              <div v-if="!Registered">
                <hr />

                <div class="linkFrame">
                  <a href="https://www.chanchao.com.tw/accounts/vn/login">Hội viên đăng nhập</a>

                  <span class="linkText ml-2 pl-2">
                    <span class="linkLine"></span>
                    <a href="https://www.chanchao.com.tw/accounts/vn/signup">Đăng ký ngay</a>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  </div>
</template>

<script>
  import Footer from '@/components/footer_en.vue'

  export default {
    components: {
      Footer,
    },
    data() {
      return {
        password: '',
        confirmcode: '',
        typePwd: 'password',
        access_token: '',
        alertTitle: '',
        alertText: '',
        lastUrl: '',
        menberId: '',
        verifyCode: '',
        CSRF_Token: '',
        show: false,
        Registered: false,
      }
    },

    watch: {
      password: function () {
        const vm = this
        vm.$refs.password.style.borderColor = '#ced4da'
      },

      confirmcode: function () {
        const vm = this
        vm.$refs.passwordconfirm.style.borderColor = '#ced4da'
      },
    },

    methods: {
      resetPw() {
        const vm = this
        const url = 'https://www.chanchao.com.tw/apiLogin2/resetPw'
        const resetinfo = {
          spass: vm.password,
          c: vm.verifyCode,
          e: vm.menberId,
          CSRF: vm.CSRF_Token,
        }

        vm.$validator.validate().then((valid) => {
          if (valid) {
            if (vm.password.length > 7) {
              vm.$http.post(url, resetinfo).then(function (response) {
                // // console.log(response)
                if (response.data == '200') {
                  vm.alertTitle = 'Thành công'
                  vm.alertText =
                    'Mật khẩu mới của bạn đã cài đặt lại thành công, xin vui lòng sử dụng mật khẩu mới để đăng nhập！'
                  vm.alertSuccess()
                } else if (response.data == '252') {
                  window.location.replace('https://www.chanchao.com.tw/vn/')
                } else {
                  vm.alertText = 'Hệ thống đang bận, vui lòng đăng nhập sau！'
                  vm.alertError()
                }
              })
            } else {
              vm.alertText = 'Mật khẩu 8-20 ký tự！'
              vm.alertError()
              vm.$refs.password.style.borderColor = 'red'
              vm.$refs.passwordconfirm.style.borderColor = 'red'
            }
          } else {
            vm.alertText = 'Thông tin chưa hoàn thiện, xin vui lòng kiểm tra lại！'
            vm.alertError()
          }
        })
      },

      alertError() {
        const vm = this
        vm.$swal({
          title: vm.alertTitle,
          text: vm.alertText,
          icon: 'info',
          confirmButtonText: 'OK',
          // animation: false,
          allowOutsideClick: true,
          confirmButtonColor: '#abc6d2',
          width: 300,
          padding: 15,
        })
      },

      alertSuccess() {
        const vm = this

        vm.$swal({
          title: vm.alertTitle,
          text: vm.alertText,
          icon: 'success',
          confirmButtonText: 'OK',
          // animation: false,
          allowOutsideClick: true,
          confirmButtonColor: '#abc6d2',
          width: 300,
          padding: 15,
        }).then(function () {
          const url = 'https://www.chanchao.com.tw/apiLogin2/Logout'

          vm.$http.get(url).then(function (response) {
            document.location.href = 'https://www.chanchao.com.tw/accounts/vn/login'
          })
        })
      },

      showPw() {
        const vm = this
        vm.typePwd = vm.typePwd === 'password' ? 'text' : 'password'
      },
    },

    created() {
      const vm = this

      vm.$http.get('https://www.chanchao.com.tw/apiLogin2/CSRF_Token').then((response) => {
        vm.CSRF_Token = response.data
      })

      let getUrlString = location.href
      let getParams = new URL(getUrlString)

      let memberid = getParams.searchParams.get('e')
      let vCode = getParams.searchParams.get('c')

      vm.menberId = memberid
      vm.verifyCode = vCode

      const url = `https://www.chanchao.com.tw/apiLogin2/resetPw/${memberid}/${vCode}`

      vm.$http.get(url).then(function (response) {
        if (response.data == 251 || response.data == 252) {
          alert('Liên kết đã hết hạn, xin vui lòng thử cài đặt lại mật khẩu')
          vm.$router.push({ path: '/forgetPw' })
        } else {
          vm.show = true
        }
      })

      //更換英文語系
      vm.$i18n.locale = 'vi'

      //是否登入狀態

      const url2 = 'https://www.chanchao.com.tw/apiLogin2/isAuthenticated'
      const info = null

      vm.$http.post(url2, info).then(function (response) {
        // console.log(response.data)
        if (response.data == 200) {
          vm.Registered = true
        } else {
          vm.Registered = false
        }
      })
    },
  }
</script>

<style lang="scss" scoped>
  //Swal setting

  .navLogo {
    height: 55px;
  }

  .logoText {
    font-size: 20px;
  }

  .swal2-popup {
    font-size: 13px !important;
  }

  .swal2-styled.swal2-confirm {
    font-size: 10px;
  }

  #main-footer {
    bottom: 0;
  }

  .menuFrame {
    background-color: #f2f2f2;
    min-height: 100%;
    font-family: Arial;
  }

  .title_family {
    font-family: 'sans-serif';
  }

  .formFrame {
    background-color: #ffffff;
    margin-top: 40px;
    border-radius: 10px;
    box-shadow: 1px 1px 1px 1px rgba(201, 199, 199, 0.5);
  }

  .navEnText:hover {
    color: rgb(34, 34, 34) !important;
  }

  .navHead {
    font-size: 29px;
    color: #2c3e50;
  }

  .navCnt {
    font-size: 17px;
  }

  @media (max-width: 768px) {
    .navLogo {
      height: 50px;
    }
    .lineBottom {
      border-top: 0.5px solid rgb(230, 227, 227);
      padding-top: 30px;
    }

    .navEnText {
      display: none;
    }

    .navHead {
      font-size: 23px;
      color: #2c3e50;
    }

    .navCnt {
      font-size: 14px;
    }

    .logoText {
      font-size: 16px;
    }
  }

  @media (max-width: 992px) {
    .auth-code {
      margin-top: 20px;
      margin-bottom: 20px;
    }
  }

  .input-note {
    font-size: 14px;
    color: rgb(190, 67, 67);
  }

  input::-webkit-input-placeholder {
    /* placeholder*/
    color: #aab2bd;
    font-size: 14px;
  }

  .linkFrame {
    font-size: 15px;
  }

  .linkText {
    position: relative;
  }

  .linkLine {
    position: absolute;
    height: 13px;
    //width: 33px;
    top: 20%;
    left: 0;
    border-left: 2px solid #a1a7a8;
  }
</style>
